<!-- <div class="custella-modal">
    <div class="custella-modal-header align-items-center">
        <div class="custella-modal-header-text">
            <span>Assign task</span>
        </div>
        <i class="fa-regular fa-xmark fa-lg" (click)="modalRef.hide()"></i>
    </div>
     <div class="custella-modal-body p-0">
        <div class="custella-form-container box-none m-0">
            <div class="custella-form-container-content my-3">
                <div class="custella-content-row pe-0">
                    <div class="custella-content-row-input col-12 me-0"> 
                        <div class="custella-content-row-input-title">Assign to</div>
                        <p-dropdown placeholder="Order Owner"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="custella-modal-footer flex-align-center justify-content-between">
            <div class="flex-align-center gap-2">
                <div class="p-field-checkbox"><p-checkbox [binary]="true"></p-checkbox></div>
                <span class="text-12">Apply to all added tasks</span>
            </div>

            <div class="flex-align-center">
                <button type="button"class="custella-btn-white text-12 ms-2" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                <p-button type="button" [label]="translate?.general.buttons.confirm.singular" styleClass="ms-2 h-32"></p-button>
            </div>
        </div>
     </div>
</div> -->

<!-- Assign Task Modal -->
<div class="flx-modal" role="dialog" aria-modal="true" aria-labelledby="assignTitle">
    <div class="flx-modal__header">
        <h2 id="assignTitle">{{translate?.general.buttons.assign.singular}} {{translate?.task.label.singular}}</h2>
        <button class="icon-btn" aria-label="Close" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <form [formGroup]="assigneeForm">
        <div class="flx-modal__body">
            <label class="field-label">{{translate?.general.buttons.assign.singular}} {{translate?.general.messages.to}}</label>

            <div class="field-row field-row--auto" [ngClass]="{'mb-0 row-gap-no': assigneeForm.get('assignTo').value == 'user'}">
                <p-dropdown 
                [options]="assignedToOptions"
                formControlName="assignTo"
                optionLabel="name"
                optionValue="value" 
                (onChange)="onAssignToChange()">
                </p-dropdown>

                <!-- <p-autoComplete
                    [placeholder]="translate?.general.messages.none"
                    [suggestions]="users"
                    optionLabel="fullName"
                    id="picklist_TaskUserField"
                    name="users"
                    [(ngModel)]="searchUserVal"
                    (completeMethod)="getSearchedUserList(searchUserVal)"
                    (onSelect)="addUser($event)"
                >
                    <ng-template let-user pTemplate="item">
                        <div class="d-flex align-items-center border p-1" style="border-radius: 4px;">
                            <p-avatar *ngIf="user.imageUrl" [image]="user.imageUrl" styleClass="mr-2 mt-2" shape="circle" id="img_TaskAvatar"></p-avatar>
                            <p-avatar *ngIf="!user.imageUrl" image="assets/svg/Avatar.svg" id="img_TaskAvatar" styleClass="mr-2 mt-2" shape="circle"></p-avatar>
                            <span class="ms-1" id="label_TaskUserFullName">{{ user?.fullName }}</span>
                        </div>
                    </ng-template>
                </p-autoComplete> -->

                <p-dropdown 
                placeholder="{{translate?.general.buttons.select2.singular}}  {{ assignToLabel }}" 
                    filter="true"
                    [options]="userList" 
                    optionLabel="fullName" 
                    optionValue="id"
                    formControlName="assignToGroup" 
                    *ngIf="assigneeForm.get('assignTo').value && assigneeForm.get('assignTo').value == 'user'">
                </p-dropdown>
                <div>
                    <p-dropdown placeholder="{{translate?.general.buttons.select2.singular}}  {{ assignToLabel }}" 
                        filter="true"
                        [options]="groupList"
                        optionLabel="name" 
                        optionValue="id"
                        formControlName="assignToGroup" 
                        *ngIf="assigneeForm.get('assignTo').value && assigneeForm.get('assignTo').value == 'group'">
                    </p-dropdown>
                    <div class="p-error text-10" *ngIf=" assigneeForm.controls['assignToGroup'].touched && assigneeForm.controls['assignToGroup'].hasError('required') ">
                        <span *ngIf="assigneeForm.controls['assignToGroup'].errors?.required" id="label_AssetLocStreetReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                    </div>
                </div>
            </div>

            <div class="note" *ngIf="assigneeForm.get('assignTo').value == 'group'">
                <div class="icon">
                    <i class="fa-regular fa-circle-info" aria-hidden="true"></i>
                </div>
                <p>
                    {{translate?.task.label.plural}} {{translate?.jobOrder.messages.willBeAssigned}}.
                </p>
            </div>
        </div>

        <div class="flx-modal__footer-between">
            <div class="apply" >
                <ng-container *ngIf="!['jo-temp-task-standalone','jo-task-standalone'].includes(isModalFrom)">
                    <div class="p-field-checkbox">
                        <p-checkbox [binary]="true" formControlName="applyToAllTask"></p-checkbox>
                    </div>
                    <span class="text-12">{{translate?.general.buttons.apply.singular}} {{translate?.jobOrder.messages.toAllAdded}} {{translate?.task.label.plural}}</span>
                </ng-container>
            </div>
            <div class="triggers">
                <button type="button"class="custella-btn-white"(click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                <p-button type="button" [label]="translate?.general.buttons.confirm.singular" styleClass="h-32" (onClick)="onConfirmClick()"></p-button>
            </div>
        </div>
    </form>
</div>
